var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCharacter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 226.194,
    height: 320.506,
    viewBox: "0 0 226.194 320.506",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3312",
    "data-name": "Group 3312",
    transform: "translate(-174.747 -36.052) rotate(-19)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3302",
    "data-name": "Group 3302"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3301",
    "data-name": "Group 3301"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union_17",
    "data-name": "Union 17",
    d: "M-4667.708-12784.135l-12.119-41.028,40.649,22.518,14.864-49.677-.165-.021a.448.448,0,0,0-.013-.046c-.469-1.466-10.032-12.238-13.5-16.364a2.287,2.287,0,0,1,.605-3.347,2.637,2.637,0,0,1,3.178.022l4.084,3.159-3.33-17.863a2.568,2.568,0,0,1,1.99-2.994,2.215,2.215,0,0,1,2.6,1.6l3.032,11.161.922-.029-.259-14.889a2.552,2.552,0,0,1,2.35-2.622,2.2,2.2,0,0,1,2.324,1.877l2.2,15.443.738-.02.994-13.245a2.8,2.8,0,0,1,2.8-2.605,2.437,2.437,0,0,1,2.369,2.518l-.149,13.181c.113,0,.227-.006.34-.006l2.618-10.615a2.262,2.262,0,0,1,2.259-1.776,1.982,1.982,0,0,1,1.883,2.094l-1.851,10.181s1.871,17.165-1.676,23.488a2.714,2.714,0,0,1-1.07.993c-.471,23.529-8.893,60.94-11.405,71.615-.987,5.376-3.434,10.874-9.229,11.783a13.073,13.073,0,0,1-2.029.146C-4644.259-12769.5-4667.708-12784.135-4667.708-12784.135Z",
    transform: "translate(4932.499 13046.324)",
    fill: "#fff",
    stroke: "#25292b",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6509",
    "data-name": "Path 6509",
    d: "M303.312,178.135s7.366-3.9,12.281,6.029",
    fill: "none",
    stroke: "#25292b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.183
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3295",
    "data-name": "Group 3295"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3294",
    "data-name": "Group 3294"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union_18",
    "data-name": "Union 18",
    d: "M-4679.795-12767.176c-1.184-7.913,28.5-14.747,28.5-14.747l16.582-111.685,31.021-.955-29.651,114.648c3.393,11.7-10.256,12.738-10.256,12.738Z",
    transform: "translate(4769 13174.311)",
    fill: "#fff",
    stroke: "#25292b",
    strokeWidth: 1
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_6477",
    "data-name": "Path 6477",
    d: "M171.876,364.448v50.868l45.939,1.178V380.052l9.916-1.729,6.666,36.992,41.558,2.641-16.182-76.362Z",
    fill: "#25292b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Union_13",
    "data-name": "Union 13",
    d: "M-4638.873-12814.993l-40.955-14.72c20.4-54.9,57.121-52.02,57.31-52v0l42.628-7.593s25.17-16.7,64.31,9.481l-22.964,36.331-5.772-.534,12.072,82.108-101.345,14.436Z",
    transform: "translate(4800.887 13113.455)",
    fill: "#fff",
    stroke: "#25292b",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3303",
    "data-name": "Group 3303"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_55",
    "data-name": "Line 55",
    x1: 2.693,
    y1: 24.655,
    transform: "translate(159.323 273.807)",
    fill: "none",
    stroke: "#25292b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.14
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_56",
    "data-name": "Line 56",
    x1: 3.903,
    y1: 21.285,
    transform: "translate(252.669 248.135)",
    fill: "none",
    stroke: "#25292b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.14
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3311",
    "data-name": "Group 3311"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6492",
    "data-name": "Path 6492",
    d: "M186.2,226.178h0l-4.693-28.6,26.361-4.327,4.693,28.6,8.435,2.29s.1,12.154-19.317,15.611-23.312-8.016-23.312-8.016Z",
    fill: "#fff",
    stroke: "#25292b",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6493",
    "data-name": "Path 6493",
    d: "M209.354,202.294s-.441,11.233-10.058,14.094c-11.069,3.292-16.259-9.491-16.259-9.491s5.985,5.207,13.886,3.92A17.683,17.683,0,0,0,209.354,202.294Z",
    transform: "translate(0 -1)",
    opacity: 0.11
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6494",
    "data-name": "Path 6494",
    d: "M177.783,151.36s4.692-11.621,20.47-9.709c11.136,1.349,14.858,10.43,16.821,14.564a10.152,10.152,0,0,1,.963,5.075l-2.164,19.474L195.4,155.956,180.177,158.7Z",
    fill: "#25292b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Union_14",
    "data-name": "Union 14",
    d: "M-4666.315-12845.844a31.269,31.269,0,0,1-2.632-5.5l0,.012a4.929,4.929,0,0,1-3.855,1.428c-6.315-.66-9.176-10.493-5.208-12.468a4.966,4.966,0,0,1,6.286,1.007c.038.2.085.429.139.674a93.253,93.253,0,0,1-1.547-10.019s-2.146-21.572,19.174-23.7c22.456-2.233,23.922,19.294,23.922,19.294a106.194,106.194,0,0,1,.52,10.623c.013-.4.019-.77.014-1.078a4.964,4.964,0,0,1,5.965-2.224c4.279,1.155,3.408,11.354-2.651,13.247a4.932,4.932,0,0,1-3.949-.565,31.976,31.976,0,0,1-1.6,6.6c-2.784,7.389-7.182,11.008-14.717,11.985a28.662,28.662,0,0,1-3.678.252C-4656.226-12836.271-4661.792-12838.592-4666.315-12845.844Z",
    transform: "translate(4843.372 13046.324)",
    fill: "#fff",
    stroke: "#25292b",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3306",
    "data-name": "Group 3306"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3305",
    "data-name": "Group 3305"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3304",
    "data-name": "Group 3304"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6496",
    "data-name": "Path 6496",
    d: "M219.37,182.154s-3.569-.809-5.516,4.522",
    fill: "none",
    stroke: "#131313",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.698
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3309",
    "data-name": "Group 3309"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3308",
    "data-name": "Group 3308"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3307",
    "data-name": "Group 3307"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6498",
    "data-name": "Path 6498",
    d: "M166.536,187.409s3.34-1.5,6.3,3.347",
    fill: "none",
    stroke: "#131313",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.698
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_6500",
    "data-name": "Path 6500",
    d: "M171.651,184.964,165.936,166.4a8.176,8.176,0,0,1,.2-4.6c1.278-3.7,5.2-12,11.648-10.438l2.394,7.338s-7.755,2.385-9.9,13.054Z",
    fill: "#25292b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6501",
    "data-name": "Path 6501",
    d: "M175.3,157.694s14.254,14.139,39.44,10.092c0,0-4.222-18.042-16.062-18.169a41.376,41.376,0,0,0-21.113,6.016Z",
    fill: "#25292b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6502",
    "data-name": "Path 6502",
    d: "M180.177,158.7a38.6,38.6,0,0,1-10.056,15.715S166.705,157.4,180.177,158.7Z",
    fill: "#25292b"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3310",
    "data-name": "Group 3310"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6503",
    "data-name": "Path 6503",
    d: "M199.861,180.38a1.907,1.907,0,1,0,1.587-2.179A1.905,1.905,0,0,0,199.861,180.38Z",
    fill: "#25292b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6504",
    "data-name": "Path 6504",
    d: "M182.2,183.155a1.907,1.907,0,1,0,1.588-2.18A1.908,1.908,0,0,0,182.2,183.155Z",
    fill: "#25292b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6505",
    "data-name": "Path 6505",
    d: "M186.4,173.764l-12.151,5.262s.018-3.643,5-5.748S186.4,173.764,186.4,173.764Z",
    fill: "#25292b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6506",
    "data-name": "Path 6506",
    d: "M195.3,172.528l13.179,1.282s-1.134-3.463-6.518-3.939S195.3,172.528,195.3,172.528Z",
    fill: "#25292b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6507",
    "data-name": "Path 6507",
    d: "M192,186.246l.55,2.68a1.067,1.067,0,0,0,1.455.795l1.365-.59",
    fill: "none",
    stroke: "#25292b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.026
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6508",
    "data-name": "Path 6508",
    d: "M188.028,195.068l13.716-3.1s1.128,5.331-5.622,6.636S188.028,195.068,188.028,195.068Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCharacter);
export default __webpack_public_path__ + "static/media/character.999d33d64cace584ef9529c968a70d2d.svg";
export { ForwardRef as ReactComponent };